import { TALENT_DETAIL_PATH, TALENT_PATH } from '@/constants/routes';

export const TALENT_LIST_SCROLL_PARAM = 'talentListScrollY';

const TALENT_DETAIL_ONLY_PARAMS = ['talentDetailTab'];

type SearchParamsInput = string | URLSearchParams;

const createParams = (searchParams: SearchParamsInput) => new URLSearchParams(searchParams);

const toPathWithParams = (path: string, params: URLSearchParams) => {
  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
};

const normalizeScrollY = (scrollY?: number) => {
  if (scrollY == null || !Number.isFinite(scrollY)) return null;
  return Math.max(0, Math.round(scrollY)).toString();
};

export const createTalentDetailPath = (
  talentId: string,
  currentSearchParams: SearchParamsInput,
  scrollY?: number,
) => {
  const params = createParams(currentSearchParams);
  const normalizedScrollY = normalizeScrollY(scrollY);

  if (normalizedScrollY != null) {
    params.set(TALENT_LIST_SCROLL_PARAM, normalizedScrollY);
  }

  return toPathWithParams(TALENT_DETAIL_PATH.replace(':userId', talentId), params);
};

export const createTalentListPath = (currentSearchParams: SearchParamsInput) => {
  const params = createParams(currentSearchParams);

  TALENT_DETAIL_ONLY_PARAMS.forEach((param) => params.delete(param));

  return toPathWithParams(TALENT_PATH, params);
};

export const getTalentListScrollY = (currentSearchParams: SearchParamsInput) => {
  const params = createParams(currentSearchParams);
  const rawScrollY = params.get(TALENT_LIST_SCROLL_PARAM);

  if (rawScrollY == null || rawScrollY.trim() === '') return null;

  const scrollY = Number(rawScrollY);

  if (!Number.isFinite(scrollY) || scrollY < 0) return null;

  return scrollY;
};
